'use client'

import styled from 'styled-components'

export const Body = styled.body`
  background-color: ${o => o.theme.color.fill.background};
  color: ${o => o.theme.color.text.primary.on.background};
`

export const FullHeightBody = styled(Body)`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
`
